import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Col } from "react-bootstrap";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import { dollars } from "LIB/formatters/currency";
import { withFieldsFromForm } from "MODULES/shared/decorators";
import Form from "./Form";

function InternalOutrightSaleModal({
  visible,
  close,
  lineItem,
  outright_value
}) {
  const initialValues = {
    outright_value: Number(
      get(lineItem, "most_recent_repair_item.original_evaluation")
    ),
    credit_exchange: false
  };

  return (
    <Modal open={visible} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Internal Outright Sale</h4>
      </Header>
      {lineItem.received &&
        lineItem.most_recent_repair_item && (
          <Col md={12}>
            <div style={{ marginTop: "10px" }} className="alert alert-warning">
              <div className="media">
                <div className="media-left">
                  <i className="fa fa-lg fa-warning text-warning" />
                </div>
                <div className="media-body">
                  &nbsp;Internal Outright Sale is being created from{" "}
                  {lineItem.sales_order_code} for the Original Evaluation
                  estimate of {dollars(outright_value)} from{" "}
                  {lineItem.most_recent_repair_item.repair_order_code}.
                  Continue?
                </div>
              </div>
            </div>
          </Col>
        )}
      <Form
        close={close}
        lineItem={lineItem}
        initialValues={initialValues}
        enableReinitialize
      />
    </Modal>
  );
}

export default withFieldsFromForm("internalOutrightSaleForm", [
  "outright_value"
])(InternalOutrightSaleModal);

InternalOutrightSaleModal.propTypes = {
  visible: T.bool.isRequired,
  close: T.func.isRequired,
  lineItem: T.shape({}),
  outright_value: T.number
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/InternalOutrightSale/InternalOutrightSaleModal.jsx